
const React = window.React;
const create = (type, props, key, spread) => {
  const { children, ...rest } = props || {};
  if (key !== undefined) rest.key = key;
  if (children === undefined) return React.createElement(type, rest);
  return spread && Array.isArray(children) ? React.createElement(type, rest, ...children) : React.createElement(type, rest, children);
};
module.exports = {
  Fragment: React.Fragment,
  jsx: (type, props, key) => create(type, props, key, false),
  jsxs: (type, props, key) => create(type, props, key, true),
};
